import { Injectable } from '@angular/core';
import {RegistrationService} from '../../registration.service';
import {RegistrationStorageService} from '../../../../../shared/services/registration-storage.service';

@Injectable({
  providedIn: 'root'
})
export class InsurerContactDataService {

  constructor(private registrationService: RegistrationService,
              private registrationStorage: RegistrationStorageService) {
  }

  get contactDataBean(): any {
    return {
      ...this.registrationService.contactData
    };
  }

  changeEmail(email: string): void {
    this.registrationService.contactData.email = email;
    this.registrationStorage.updateRegistration();
  }

  changePhoneNumber(phoneNumber: string): void {
    this.registrationService.contactData.phoneNumber = phoneNumber;
    this.registrationStorage.updateRegistration();
  }

}
